const urlObject = new URL(window.location.href);

// Extract path parameters
const getPathParams = () => urlObject.pathname.split("/").filter((part) => part !== "");
const getQueryParams = (): any => {
  const queryParams: Record<string, string> = {};
  urlObject.searchParams.forEach((value, key) => {
    queryParams[key] = value;
  });
  return queryParams;
};

const URLParamService = { urlObject, getPathParams, getQueryParams };

export default URLParamService;
